import ApiService, { ApiArguments } from '@/api/api_service';
import {
  NextActionSuggestionDefaultSettingApi,
  NextActionSuggestionDefaultSettingApiPutNextActionSuggestionDefaultSettingRequest,
  NextActionSuggestionDefaultSettingBody,
} from '@/api/openapi';

export class NextActionSuggestionDefaultSettingApiService extends ApiService {
  api = new NextActionSuggestionDefaultSettingApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getNextActionSuggestionDefaultSetting(
    apiArguments?: ApiArguments<undefined>,
  ) {
    return this.checkResponse<NextActionSuggestionDefaultSettingBody>(
      this.api.getNextActionSuggestionDefaultSetting(apiArguments?.options),
      apiArguments?.errorHandlers,
    );
  }

  async putNextActionSuggestionDefaultSetting({
    request,
    options,
    errorHandlers,
  }: ApiArguments<NextActionSuggestionDefaultSettingApiPutNextActionSuggestionDefaultSettingRequest>) {
    return this.checkResponse<void>(
      this.api.putNextActionSuggestionDefaultSetting(request, options),
      errorHandlers,
    );
  }
}
